import { render } from "./PricingCalculator.vue?vue&type=template&id=e4565fca&scoped=true"
import script from "./PricingCalculator.vue?vue&type=script&lang=js"
export * from "./PricingCalculator.vue?vue&type=script&lang=js"

import "./PricingCalculator.vue?vue&type=style&index=0&id=e4565fca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4565fca"]])

export default __exports__